<template>
  <error404 />
</template>

<script setup name="login">
import Error404 from "@/component/Error.vue"
</script>

<style scoped lang="scss">
</style>
